import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {AdminService} from '../admin.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(private adminService: AdminService,
              private router: Router) { }

  ngOnInit(): void {
    this.adminService.logout();
    this.router.navigate(['/login'], {}).then();
  }

}
